import React from 'react'
import { HPI_GROUPS } from '../../Components/utils';

const HPIFields = (props) => {
    // HistoryOfPresentIllness
    let { hpiData, setSubjectiveData, setSaveHPIData } = { ...props };
    console.log("hpiData", hpiData)
    const handleHPI = (e) => {
        let { name } = e.target;
        setSubjectiveData(prev => {
        
           return ({
                ...prev,
                'HistoryOfPresentIllness': {
                    ...prev?.HistoryOfPresentIllness,
                    [name]: prev?.HistoryOfPresentIllness?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveHPIData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }

  return (
    <div className="observation-content HPI-scroll d-flex flex-column gap-12">
        {HPI_GROUPS.map((group, groupIndex) => {
        // Get only items that exist in your hpiData
        const groupItems = group.items || [];

        return (
            <div key={group.title + groupIndex} className="d-flex flex-column gap-1">
            <p className="heading font-m">{group.title}</p>

            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">
                {groupItems.map((item, index) => (
                <label
                    key={item.key}
                    className="d-flex align-items-center gap-6 user-select-none"
                >
                    <div className="custom_check_box d-flex">
                    <input
                        type="checkbox"
                        className="form-check-input m-0 p-0"
                        name={item.key}
                        checked={hpiData?.[item.key] === "true"}
                        onChange={handleHPI}
                    />
                    </div>
                    <p className="text lh-12">{item.label}</p>
                </label>
                ))}
            </div>
            </div>
        );
        })}

        {/* <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Chronicity</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox" 
                    className="form-check-input m-0 p-0" 
                    name="Ch_New"
                    checked={hpiData?.Ch_New === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">New</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox" 
                    className="form-check-input m-0 p-0"
                    name="Ch_Recurrent"
                    checked={hpiData?.Ch_Recurrent === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Recurrent</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox" 
                    className="form-check-input m-0 p-0"
                    name="Ch_Chronic"
                    checked={hpiData?.Ch_Chronic === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Chronic</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox" 
                    className="form-check-input m-0 p-0"
                    name="Ch_Other"
                    checked={hpiData?.Ch_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Onset Date</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox" 
                    className="form-check-input m-0 p-0" 
                    name="On_Today"
                    checked={hpiData?.On_Today === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Today</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="On_Yesterday"
                    checked={hpiData?.On_Yesterday === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Yesterday</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="On_Last7Days"
                    checked={hpiData?.On_Last7Days === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Last 7 days</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="On_OneToFourWeeks"
                    checked={hpiData?.On_OneToFourWeeks === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">1 - 4 weeks ago</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="On_MoreThanOneMonth"
                    checked={hpiData?.On_MoreThanOneMonth === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">More than 1 month ago</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="On_MoreThanOneYear"
                    checked={hpiData?.On_MoreThanOneYear === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">More than 1 year ago</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Duration / Lasts For</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_Seconds"
                    checked={hpiData?.Dur_Seconds === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Seconds</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_Minutes"
                    checked={hpiData?.Dur_Minutes === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Minutes</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_Hours"
                    checked={hpiData?.Dur_Hours === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Hours</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_AllDay"
                    checked={hpiData?.Dur_AllDay === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">All day</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_SeveralDays"
                    checked={hpiData?.Dur_SeveralDays === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Several Days</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_Weeks"
                    checked={hpiData?.Dur_Weeks === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Weeks</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_Constant"
                    checked={hpiData?.Dur_Constant === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Constant</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_Intermittent"
                    checked={hpiData?.Dur_Intermittent === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Intermittent</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Dur_Other"
                    checked={hpiData?.Dur_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Frequency</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Freq_Constantly"
                    checked={hpiData?.Freq_Constantly === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Constantly</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Freq_Daily"
                    checked={hpiData?.Freq_Daily === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Daily</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Freq_TwoToFourPerDay"
                    checked={hpiData?.Freq_TwoToFourPerDay === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">2 to 4 times per day</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Freq_EverySeveralDays"
                    checked={hpiData?.Freq_EverySeveralDays === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Every several days</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Freq_Intermittently"
                    checked={hpiData?.Freq_Intermittently === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Intermittently</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Freq_Rarely"
                    checked={hpiData?.Freq_Rarely === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Rarely</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Trend / Progression</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Tr_Unchanged"
                    checked={hpiData?.Tr_Unchanged === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Unchanged</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Tr_Resolved"
                    checked={hpiData?.Tr_Resolved === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Resolved</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Tr_GraduallyImproving"
                    checked={hpiData?.Tr_GraduallyImproving === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Gradually improving</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Tr_RapidlyImproving"
                    checked={hpiData?.Tr_RapidlyImproving === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Rapidly improving</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Tr_GraduallyWorsening"
                    checked={hpiData?.Tr_GraduallyWorsening === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Gradually worsening</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Tr_RapidlyWorsening"
                    checked={hpiData?.Tr_RapidlyWorsening === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Rapidly worsening</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Pain Severity</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Ps_NoPain"
                    checked={hpiData?.Ps_NoPain === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">No pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Ps_Mild"
                    checked={hpiData?.Ps_Mild === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Mild</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Ps_Moderate"
                    checked={hpiData?.Ps_Moderate === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Moderate</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Ps_Severe"
                    checked={hpiData?.Ps_Severe === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Severe</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Pain numeric</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_0"
                    checked={hpiData?.Pn_0 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">0/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_1"
                    checked={hpiData?.Pn_1 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">1/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_2"
                    checked={hpiData?.Pn_2 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">2/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_3"
                    checked={hpiData?.Pn_3 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">3/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_4"
                    checked={hpiData?.Pn_4 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">4/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_5"
                    checked={hpiData?.Pn_5 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">5/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_6"
                    checked={hpiData?.Pn_6 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">6/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_7"
                    checked={hpiData?.Pn_7 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">7/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_8"
                    checked={hpiData?.Pn_8 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">8/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_9"
                    checked={hpiData?.Pn_9 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">9/10</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pn_10"
                    checked={hpiData?.Pn_10 === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">10/10</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Pain Quality</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Sharp"
                    checked={hpiData?.Pq_Sharp === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Sharp</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Shooting"
                    checked={hpiData?.Pq_Shooting === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Shooting</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Cramping"
                    checked={hpiData?.Pq_Cramping === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Cramping</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Throbbing"
                    checked={hpiData?.Pq_Throbbing === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Throbbing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Stabbing"
                    checked={hpiData?.Pq_Stabbing === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Stabbing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Numbing"
                    checked={hpiData?.Pq_Numbing === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Numbing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Tingling"
                    checked={hpiData?.Pq_Tingling === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Tingling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Burning"
                    checked={hpiData?.Pq_Burning === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Burning</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Aching"
                    checked={hpiData?.Pq_Aching === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Aching</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pq_Other"
                    checked={hpiData?.Pq_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        {/* ///////////// Break //////////////// */}
        {/* 
        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Radiates to</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_DoesNotRadiate"
                    checked={hpiData?.Rad_DoesNotRadiate === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Does not radiate</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_LeftKnee"
                    checked={hpiData?.Rad_LeftKnee === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Left knee</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_RightKnee"
                    checked={hpiData?.Rad_RightKnee === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Right knee</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_Shooting"
                    checked={hpiData?.Rad_Shooting === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Shooting</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_LeftFoot"
                    checked={hpiData?.Rad_LeftFoot === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Left foot</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_RightFoot"
                    checked={hpiData?.Rad_RightFoot === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Right foot</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_LeftThigh"
                    checked={hpiData?.Rad_LeftThigh === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Left thigh</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_RightThigh"
                    checked={hpiData?.Rad_RightThigh === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Right thigh</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rad_Other"
                    checked={hpiData?.Rad_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Pain Pattern</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pat_WorseDuringDay"
                    checked={hpiData?.Pat_WorseDuringDay === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Worse during day</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pat_WorseDuringNight"
                    checked={hpiData?.Pat_WorseDuringNight === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Worse during night</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Pat_SameAllTheTime"
                    checked={hpiData?.Pat_SameAllTheTime === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Same all the time</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Aggravated by</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Bending"
                    checked={hpiData?.Agg_Bending === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Bending</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_PositionChange"
                    checked={hpiData?.Agg_PositionChange === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Position Change</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Sitting"
                    checked={hpiData?.Agg_Sitting === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Sitting</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Standing"
                    checked={hpiData?.Agg_Standing === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Standing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Stress"
                    checked={hpiData?.Agg_Stress === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Stress</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Coughing"
                    checked={hpiData?.Agg_Coughing === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Coughing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Exertion"
                    checked={hpiData?.Agg_Exertion === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Exertion</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Twisting"
                    checked={hpiData?.Agg_Twisting === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Twisting</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Turning"
                    checked={hpiData?.Agg_Turning === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Turning</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Walking"
                    checked={hpiData?.Agg_Walking === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Walking</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_DeepBreaths"
                    checked={hpiData?.Agg_DeepBreaths === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Deep Breaths</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Nothing"
                    checked={hpiData?.Agg_Nothing === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Nothing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Agg_Other"
                    checked={hpiData?.Agg_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Alleviating Factor</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_Nothing"
                    checked={hpiData?.Aliv_Nothing === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Nothing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_ChiropracticTreatment"
                    checked={hpiData?.Aliv_ChiropracticTreatment === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Chiropractice treatment</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_Ice"
                    checked={hpiData?.Aliv_Ice === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Ice</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_NSAIDs"
                    checked={hpiData?.Aliv_NSAIDs === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">NSAIDs</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_Injections"
                    checked={hpiData?.Aliv_Injections === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Injections</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_Heat"
                    checked={hpiData?.Aliv_Heat === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Heat</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_MuscleRelaxant"
                    checked={hpiData?.Aliv_MuscleRelaxant === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Muscle relaxant</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_Walking"
                    checked={hpiData?.Aliv_Walking === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Walking</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_BedRest"
                    checked={hpiData?.Aliv_BedRest === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Bed Rest</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_HomeExercises"
                    checked={hpiData?.Aliv_HomeExercises === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Home Exercises</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_Supplements"
                    checked={hpiData?.Aliv_Supplements === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Supplements</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Aliv_Other"
                    checked={hpiData?.Aliv_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Associated Symptoms</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_Fever"
                    checked={hpiData?.Sym_Fever === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Fever</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_Headache"
                    checked={hpiData?.Sym_Headache === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Headache</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_Weakness"
                    checked={hpiData?.Sym_Weakness === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Weakness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_Numbness"
                    checked={hpiData?.Sym_Numbness === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Numbness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_Tingling"
                    checked={hpiData?.Sym_Tingling === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Tingling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_WeightLoss"
                    checked={hpiData?.Sym_WeightLoss === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Weight loss</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_ChestPain"
                    checked={hpiData?.Sym_ChestPain === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Chest pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_Dysuria"
                    checked={hpiData?.Sym_Dysuria === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Dysuria</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_LegPain"
                    checked={hpiData?.Sym_LegPain === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Leg pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Sym_Other"
                    checked={hpiData?.Sym_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Risk Factors</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_HistoryOfCancer"
                    checked={hpiData?.Rf_HistoryOfCancer === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">History of cancer</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_Menopause"
                    checked={hpiData?.Rf_Menopause === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Menopause</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_Pregnancy"
                    checked={hpiData?.Rf_Pregnancy === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Pregnancy</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_HistoryOfOsteoporosis"
                    checked={hpiData?.Rf_HistoryOfOsteoporosis === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">History of osteoporosis</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_Obesity"
                    checked={hpiData?.Rf_Obesity === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Obesity</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_RecentTrauma"
                    checked={hpiData?.Rf_RecentTrauma === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Recent trauma</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_HistoryOfSteroidUse"
                    checked={hpiData?.Rf_HistoryOfSteroidUse === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">History of steroid use</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_PoorPosture"
                    checked={hpiData?.Rf_PoorPosture === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Poor posture</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_SedentaryLifestyle"
                    checked={hpiData?.Rf_SedentaryLifestyle === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Sedentary lifestyle</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_LackOfExercise"
                    checked={hpiData?.Rf_LackOfExercise === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Lack of exercise</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Rf_Other"
                    checked={hpiData?.Rf_Other === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Other</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Response to Treatment</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_NoRelief"
                    checked={hpiData?.Resp_NoRelief === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">No relief</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Mild"
                    checked={hpiData?.Resp_Mild === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Mild</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Moderate"
                    checked={hpiData?.Resp_Moderate === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Moderate</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Significant"
                    checked={hpiData?.Resp_Significant === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Significant</p>
            </label>

        </div>
        </div>

        <div className="d-flex flex-column gap-1">
        <p className="heading font-m">Any bleeding</p>
        <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Bleeding_Yes"
                    checked={hpiData?.Bleeding_Yes === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">Yes</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Bleeding_No"
                    checked={hpiData?.Bleeding_No === "true"}
                    onChange={handleHPI}/>
            </div>
            <p className="text lh-12">No</p>
            </label>

        </div>
        </div> */}

    </div>
  )
}

export default HPIFields